export default (() => {
    const toggles = Array.from(document.querySelectorAll('.js-user-info'));
    const overlay = document.querySelector('.user-info__overlay');

    toggles.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('html').classList.toggle('user-info-active');
        });
    });

    if (overlay) {
        overlay.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('html').classList.remove('user-info-active');
        });
    }
})();
